import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error in component:', error, errorInfo);
  }

  private handleReset = () => {
    this.setState({ hasError: false, error: undefined });
  };

  private handleHardReload = () => {
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div className="flex items-center justify-center min-h-[400px] w-full bg-red-50/80 text-red-700 rounded-3xl p-8 border border-red-200 flex-col text-center shadow-sm my-6 max-w-2xl mx-auto">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4 text-red-600 font-bold text-xl">
            !
          </div>
          <h2 className="text-xl font-bold mb-2">Algo deu errado neste componente.</h2>
          <p className="text-sm opacity-80 mb-6 max-w-md">
            {this.state.error?.message || "Ocorreu uma falha temporária ao carregar este bloco visual."}
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <button
              onClick={this.handleReset}
              className="px-5 py-2.5 bg-white text-red-700 font-bold text-xs uppercase tracking-wider rounded-xl border border-red-200 hover:bg-red-50 transition-all shadow-sm"
            >
              Tentar Novamente
            </button>
            <button
              onClick={this.handleHardReload}
              className="px-5 py-2.5 bg-red-600 text-white font-bold text-xs uppercase tracking-wider rounded-xl hover:bg-red-700 transition-all shadow-sm"
            >
              Recarregar Página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
